import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-form-checkboxes',
  templateUrl: './form-checkboxes.component.html'
})

export class FormCheckboxesComponent implements OnInit {
  objectKeys = Object.keys;
  config;
  grupo: FormGroup;

  ngOnInit() {
    if (this.config.editorOpcoes.obrigatorio) {
      this.grupo.valueChanges.subscribe((value) => {
        const controls = this.grupo.controls[this.config.nome]['controls'];
        controls['hidden'].setValue(false, {emitEvent: false});
        for (const control in controls) {
          if (controls.hasOwnProperty(control) && control !== 'hidden') {
            if (controls[control].value) {
              controls['hidden'].setValue(true, {emitEvent: false});
            }
          }
        }
      });
    }
  }
}
